import { Input } from "@ster/ster-toolkit";

const BudgetInput = ({
  value,
  onChange,
  ...props
}: Omit<Parameters<typeof Input.Currency>[0], "value" | "onChange"> & {
  value?: number;
  onChange?: (newValue: number) => void;
}) => (
  <Input.Currency
    onValueChange={({ floatValue }, { source }) =>
      source === "event" && onChange?.(floatValue ?? 0)
    }
    decimalScale={0}
    value={value}
    {...props}
  />
);

export default BudgetInput;
